import { Tag as ChakraTag, TagLabel, TagCloseButton, TagRightIcon } from '@chakra-ui/react';

export default function Tag({ value, colorScheme, ...rest }) {
  if (!value) return null;

  return (
    <ChakraTag colorScheme={colorScheme} {...rest}>
      <TagLabel>{value}</TagLabel>
    </ChakraTag>
  );
}
